module.exports = __webpack_public_path__ + "static/media/24UHCHR18.9fe858d2.jpg";